import { useEffect, useState } from "react";
import { Card, Row } from "antd";

import { Background } from "../pitchDeck/background";
import { AdditionalInfo } from "../pitchDeck/additionalInfo";
import { InvestmentDetails } from "../pitchDeck/investmentDetails";
import { FooterDetails } from "../pitchDeck/footerDetails";
import { companyPitchData } from "../pitchData/companyPitchData";
import { ThePitch } from "../pitchDeck/thePitch";
import { Founder } from "../pitchDeck/founders";
import { Advisors } from "../pitchDeck/advisors";
import { NotFound } from "../../utils/notFound";
import { Interested } from "../pitchDeck/interested";

import { Resources } from "../pitchDeck/resources";
import { Overview } from "../pitchDeck/overview";
import { DynamicMetaTags } from "../../utils/dynamicMetaTags";

export const Pitch = () => {
  const pitchUrl = "template";
  const [pitchData, setPitchData] = useState({
    pitchUrl: "",
    pitchMaterial: "",
    metaTags: {
      ogTitle: "",
      ogImage: "",
      ogUrl: "",
      ogDescription: "",
    },
    additionalInfo: "",
    advisorData: [],
    founderData: [],
    interested: {
      backgroundColor: "",
    },
    overview: {
      companyName: "",
      description: "",
      socialLinks: [],
      companyAvatar: "",
      tags: [
        {
          color: "",
          title: "",
        },
      ],
      investmentOverviewDescription: "",
      investmentDetails: "",
    },
  });

  useEffect(() => {
    const selectedPitch = companyPitchData.find(
      (data) => data.pitchUrl === pitchUrl
    );
    setPitchData(selectedPitch);
  }, [pitchUrl]);
  console.log(pitchData);
  return (
    <div className="main" style={{ margin: "15px" }}>
      {pitchData ? (
        <Row
          gutter={[18, 18]}
          id="example-pitch-deck"
          style={{
            maxWidth: "1050px",
            //adjust for overall page width layout
            justifyContent: "center",
          }}
        >
          <DynamicMetaTags metaTags={pitchData.metaTags} />
          {pitchUrl === "template" && <Resources />}
          <Card>
            <Background
              background={pitchData.background}
              backgroundMobile={pitchData.backgroundMobile}
            />
            <Overview pitchData={pitchData} />
            <ThePitch pitchMaterial={pitchData.pitchMaterial} />
            <AdditionalInfo additionalInfo={pitchData.additionalInfo} />
            <Founder founderData={pitchData.founderData} />
            <Advisors advisorData={pitchData.advisorData} />
            <InvestmentDetails
              investmentDetails={pitchData.investmentDetails}
            />
            <Interested
              interested={pitchData.interested}
              paid={pitchData.paid}
            />
            <FooterDetails />
          </Card>
        </Row>
      ) : (
        <NotFound />
      )}
    </div>
  );
};
